import escudo from "../../../images/escudo.png";

function CalendarIcon({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <rect x="3" y="5" width="18" height="16" rx="2" ry="2" />
            <line x1="16" y1="3" x2="16" y2="7" />
            <line x1="8" y1="3" x2="8" y2="7" />
            <line x1="3" y1="11" x2="21" y2="11" />
        </svg>
    );
}

function PinIcon({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
            <path d="M12 2a7 7 0 0 0-7 7c0 4.92 5.4 11.82 6.03 12.6a1.25 1.25 0 0 0 1.94 0C13.6 20.82 19 13.92 19 9a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z" />
        </svg>
    );
}

function RefereesIcon({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M12 3 5 6v6c0 4.5 2.9 7.9 7 9 4.1-1.1 7-4.5 7-9V6l-7-3Z" />
            <path d="M10 12.5 11.5 14 14.5 10.5" />
        </svg>
    );
}

const getTeamCode = (teamName = "") => teamName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "")
    .substring(0, 3) || "---";

function PartidoSummaryCard({ viewModel }) {
    const {
        liga,
        stage,
        date,
        time,
        cancha,
        referees,
        home,
        away,
        quarters,
    } = viewModel;
    const aguadaWon = home.isAguada ? home.isWinner : away.isWinner;
    const aguadaBorderClass = aguadaWon ? "border-green-500/40" : "border-red-500/40";
    const rivalBorderClass = aguadaWon ? "border-red-500/40" : "border-green-500/40";
    const homeCode = getTeamCode(home.name);
    const awayCode = getTeamCode(away.name);

    return (
        <section className="bg-[#102216] rounded-xl p-4 sm:p-6 md:p-8 mb-6 md:mb-8 shadow-xl border border-white/10">
            <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-start gap-x-2 gap-y-4 md:flex md:flex-row md:justify-between md:items-center md:gap-4">
                <div className="col-start-1 row-start-2 flex flex-col justify-center items-center gap-1 flex-1 text-center w-full h-full min-w-0 md:min-w-[180px] md:w-auto md:h-auto md:gap-2">
                    <div className={`flex w-8 h-8 sm:w-12 sm:h-12 md:w-24 md:h-24 bg-[#062a1a] rounded-full items-center justify-center border-2 shrink-0 ${home.isAguada ? aguadaBorderClass : rivalBorderClass}`}>
                        {home.isAguada ? (
                            <img src={escudo} alt="Escudo de Aguada" className="w-9 h-9 sm:w-14 sm:h-14 md:w-16 md:h-16 object-contain" />
                        ) : (
                            <span className="text-sm sm:text-xl md:text-3xl font-black text-slate-400 uppercase select-none">{home.name ? home.name.charAt(0) : "?"}</span>
                        )}
                    </div>
                    <div className="md:text-center">
                        <h3 className="text-[11px] sm:text-lg md:text-[2.05rem] font-extrabold text-slate-100 leading-tight md:leading-none break-words">{home.name}</h3>
                        <span className="text-slate-400 text-[9px] sm:text-xs md:text-sm uppercase font-bold tracking-[0.12em] sm:tracking-[0.22em] mt-1 md:mt-2 block">{home.role}</span>
                    </div>
                </div>

                <div className="contents md:flex md:flex-col md:flex-1 md:text-center md:w-full">
                    <div className="col-start-1 col-span-3 row-start-1 flex flex-col items-center gap-0.5 sm:gap-1 mb-3 sm:mb-5 md:col-auto md:row-auto">
                        <span className="text-slate-400 text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em]">{liga}</span>
                        <span className="text-green-500 text-sm sm:text-[1.05rem] font-bold tracking-wide">{stage}</span>
                    </div>

                    <div className="col-start-2 row-start-2 flex items-center justify-center gap-2 sm:gap-6 md:gap-8 md:col-auto md:row-auto">
                        <span className="text-4xl sm:text-5xl md:text-7xl font-black text-slate-100 tabular-nums">{home.score}</span>
                        <span className="text-2xl sm:text-3xl font-bold text-slate-600 leading-none -mt-1">-</span>
                        <span className="text-4xl sm:text-5xl md:text-7xl font-black text-slate-100 tabular-nums">{away.score}</span>
                    </div>

                    {quarters?.length ? (
                        <div className="col-start-1 col-span-3 row-start-3 w-full max-w-sm mx-auto overflow-x-auto mt-4 sm:mt-6 md:col-auto md:row-auto">
                            <table className="w-full text-xs sm:text-[0.95rem]">
                                <thead>
                                    <tr className="text-slate-400 border-b border-white/10">
                                        <th className="py-1 text-left font-semibold">Equipo</th>
                                        {quarters.map((quarter) => (
                                            <th key={`head-${quarter.id}`} className="py-1 px-1.5 sm:px-2 font-semibold">{quarter.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="text-center font-medium">
                                    <tr className="border-b border-white/10 text-slate-100">
                                        <td className="text-left py-1.5 sm:py-2 font-bold uppercase">{homeCode}</td>
                                        {quarters.map((quarter) => (
                                            <td key={`home-${quarter.id}`} className="py-1.5 sm:py-2">{quarter.home}</td>
                                        ))}
                                    </tr>
                                    <tr className="text-slate-100">
                                        <td className="text-left py-1.5 sm:py-2 font-bold uppercase">{awayCode}</td>
                                        {quarters.map((quarter) => (
                                            <td key={`away-${quarter.id}`} className="py-1.5 sm:py-2">{quarter.away}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ) : null}
                </div>

                <div className="col-start-3 row-start-2 flex flex-col justify-center items-center gap-1 flex-1 text-center w-full h-full min-w-0 md:min-w-[180px] md:w-auto md:h-auto md:gap-2">
                    <div className={`flex w-8 h-8 sm:w-12 sm:h-12 md:w-24 md:h-24 bg-[#062a1a] rounded-full items-center justify-center border-2 shrink-0 ${away.isAguada ? aguadaBorderClass : rivalBorderClass}`}>
                        {away.isAguada ? (
                            <img src={escudo} alt="Escudo de Aguada" className="w-9 h-9 sm:w-14 sm:h-14 md:w-16 md:h-16 object-contain" />
                        ) : (
                            <span className="text-sm sm:text-xl md:text-3xl font-black text-slate-400 uppercase select-none">{away.name ? away.name.charAt(0) : "?"}</span>
                        )}
                    </div>
                    <div className="md:text-center">
                        <h3 className="text-[11px] sm:text-lg md:text-[2.05rem] font-extrabold text-slate-100 leading-tight md:leading-none break-words">{away.name}</h3>
                        <span className="text-slate-400 text-[9px] sm:text-xs md:text-sm uppercase font-bold tracking-[0.12em] sm:tracking-[0.22em] mt-1 md:mt-2 block">{away.role}</span>
                    </div>
                </div>
            </div>

            <div className="mt-5 sm:mt-8 pt-4 sm:pt-6 border-t border-white/10 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 md:gap-0 text-center">
                <div className="px-1 sm:px-2 md:px-6 sm:border-r sm:border-white/10 md:border-r md:border-white/10">
                    <p className="flex items-center justify-center gap-1 sm:gap-2 text-[10px] sm:text-xs text-green-500 font-bold uppercase tracking-[0.14em] sm:tracking-[0.24em]">
                        <CalendarIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                        <span className="hidden sm:inline">DÍA Y HORA</span>
                        <span className="sm:hidden">FECHA</span>
                    </p>
                    <p className="text-slate-100 font-semibold text-xs sm:text-[1.02rem] mt-1 sm:mt-2">{date}</p>
                    {time && time !== "-" && <p className="text-slate-100 font-semibold text-xs sm:text-[0.95rem] mt-0.5 sm:mt-1">{time}</p>}
                </div>
                <div className="px-1 sm:px-2 md:px-6 border-l border-white/10 sm:border-l-0 sm:border-t-0 sm:border-r sm:border-white/10 md:border-r md:border-white/10">
                    <p className="flex items-center justify-center gap-1 sm:gap-2 text-[10px] sm:text-xs text-green-500 font-bold uppercase tracking-[0.14em] sm:tracking-[0.24em]">
                        <PinIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                        CANCHA
                    </p>
                    <p className="text-slate-100 font-semibold text-xs sm:text-[1.02rem] mt-1 sm:mt-2 truncate">{cancha}</p>
                </div>
                <div className="col-span-2 sm:col-span-1 px-1 sm:px-2 md:px-6 border-t border-white/10 pt-3 sm:border-t-0 sm:pt-0">
                    <p className="flex items-center justify-center gap-1 sm:gap-2 text-[10px] sm:text-xs text-green-500 font-bold uppercase tracking-[0.14em] sm:tracking-[0.24em]">
                        <RefereesIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                        <span className="inline">ÁRBITROS</span>
                    </p>
                    <p className="text-slate-100 font-semibold text-xs sm:text-[1.02rem] mt-1 sm:mt-2 line-clamp-2 sm:line-clamp-none">{referees}</p>
                </div>
            </div>
        </section>
    );
}

export default PartidoSummaryCard;
